// extracted by mini-css-extract-plugin
export default {"root":"Datalist__root--36AYe","emptyFolder":"Datalist__emptyFolder--nwN7b","error":"Datalist__error--3D06o"};